import { useEffect } from "react";

function ReturnOrder() {
  useEffect(() => {
    // Load Termly script only once
    if (!document.getElementById("termly-jssdk")) {
      const script = document.createElement("script");
      script.id = "termly-jssdk";
      script.src = "https://app.termly.io/embed-policy.min.js";
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="return-wrapper">
      {/* Termly Embed */}
      <div
        name="termly-embed"
        data-id="bb49b6ff-e63a-4022-8142-0b5e3e356094"
      ></div>
    </div>
  );
}

export default ReturnOrder;
